import { useData } from "@hooks/useData";
import { iReportProPublication, ReportProPublication } from "@models/ReportProPublication";
import http from '@core/fetch';
import { components } from "@apiSchema";
import apiConfig from "@apiConfig";

const REQUEST_TYPE: keyof typeof apiConfig = 'get social media publications';
type Response = components["schemas"]["ReportProPublicationClient"][];

async function getSocialMediaPublications(): Promise<iReportProPublication[]> {
    const data = {
        latestPublicationsCount: 2
    };
    const response: Response = await http.get(REQUEST_TYPE, data);
    return (response || []).map(apiModel => new ReportProPublication({ apiModel }));
}

export function useSocialMediaPublications() {
    return useData([], getSocialMediaPublications);
}
